import { LoadingOutlined } from '@ant-design/icons'
import React from 'react'

const DEFAULT = 'default'
const INFO = 'info'
const SUCCESS = 'success'
const DANGER = 'danger'
const GRAY = 'gray'
const YELLOW = 'yellow'
const PURPLE = 'purple'
const GHOST = 'ghost'

const GRADIENT_VARIANTS = {
    1: 's-button-gradient',
    2: 's-button-gradient-2',
}

const SIZE_CLASSES = {
    small: 's-button-sm',
    middle: '',
    large: 's-button-lg',
}

const getClassName = (type, outlined, gradient, gradientVariant, size, additionalClasses) => {
    const prefix = outlined ? 's-button-outlined' : 's-button'

    let baseClass = ''
    switch (type) {
        case INFO:
            baseClass = `${prefix}-blue`
            break
        case SUCCESS:
            baseClass = `${prefix}-green`
            break
        case DANGER:
            baseClass = `${prefix}-red`
            break
        case GRAY:
            baseClass = `${prefix}-gray`
            break
        case YELLOW:
            baseClass = `${prefix}-yellow`
            break
        case PURPLE:
            baseClass = `${prefix}-purple`
            break
        case GHOST:
            baseClass = 's-button-ghost'
            break
        default:
            baseClass = prefix
    }

    return [baseClass, gradient && GRADIENT_VARIANTS[gradientVariant], SIZE_CLASSES[size], additionalClasses]
        .filter(Boolean)
        .join(' ')
}

const renderIcon = (Icon, iconStyle) => {
    if (!Icon) return null

    const style = {
        fontSize: '1.5em',
        ...iconStyle,
    }

    if (React.isValidElement(Icon)) {
        return React.cloneElement(Icon, {
            style: {
                ...style,
                ...(Icon.props.style || {}),
            },
        })
    }

    return <Icon style={style} />
}

export default function SButton({
    value = 'SButton',
    type = DEFAULT,
    outlined = false,
    gradient = false,
    gradientVariant = 1,
    size = 'middle',
    Icon,
    iconStyle,
    iconLocation = 'right',
    className,
    isLoading,
    ...rest
}) {
    return (
        <button className={getClassName(type, outlined, gradient, gradientVariant, size, className)} {...rest}>
            {iconLocation === 'left' && renderIcon(Icon, iconStyle)}
            {value}
            {iconLocation === 'right' && renderIcon(Icon, iconStyle)}
            {isLoading && <LoadingOutlined style={{ fontSize: '1.5em' }} />}
        </button>
    )
}
